import "regenerator-runtime/runtime";

import $ from 'jquery';
global.jQuery = global.$ = $;

//import "dist/compiled/semantic/semantic.min";
import 'slick-carousel';
import 'sweetalert2';

import 'tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';

import './tinymce/i18n/fr';